import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type CommentChildrenData = AnyObject

export type CommentChildrenResponse = CommentChildrenData

// eslint-disable-next-line max-len
export type CommentOrderColumn = 'id' | 'text' | 'numberOfLikes' | 'numberOfDislikes' | 'numberOfComments' | 'createdAt' | 'updatedAt';

export type CommentChildrenParams = PaginationProps<CommentOrderColumn> & {
  id: string;
  text?: string;
  category?: string;
  subCategory?: string;
  article?: string;
}

export const commentChildren = (payload: CommentChildrenParams): Action<CommentChildrenParams> => ({
  type: actions.commentChildrenTrigger.toString(),
  payload,
});

export const commentChildrenClear = (): Action => ({
  type: actions.commentChildrenClear.toString(),
});

export const commentChildrenErrorClear = (): Action => ({
  type: actions.commentChildrenErrorReset.toString(),
});

export function* commentChildrenRequestSaga({ payload }: Action<CommentChildrenParams>) {
  yield put({
    type: actions.commentChildrenStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentChildrenError.toString(),
      payload: {
        message: 'CommentChildren: Parameters not passed.',
      },
    });

    return;
  }

  const { id, ...restParams } = payload;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/comments/${id}/children?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CommentChildrenData, CommentChildrenResponse>(
    response,
    actions.commentChildrenSuccess.toString(),
    actions.commentChildrenError.toString(),
    false,
    (commentChildrenData) => commentChildrenData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentChildrenTrigger.toString(),
    defaultProcessingSaga(
      commentChildrenRequestSaga,
      {
        error: actions.commentChildrenError.toString(),
        locationCancel: actions.commentChildrenClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentChildrenSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.commentChildrenError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentChildrenErrorReset.toString(),
    });
  });
}
